<div class="page-wrapper" [ngClass]="layoutClass">
  <app-header></app-header>
  <div class="page-body-wrapper">
    <div class="sidebar-wrapper" [class.close_icon]="navService.collapseSidebar">
      <app-sidebar></app-sidebar>
    </div>
    <div class="page-body">
      <router-outlet></router-outlet>
    </div>
    <div class="toast-container position-fixed bottom-0 end-0 p-3 toast-index toast-rtl" style="z-index: 1056;">
      <div class="toast hide toast fade" id="liveToast1" [class.show]="alertShow">
          <div class="d-flex justify-content-between" [class]="typeAlert">
              <div class="toast-body">{{ messageAlert }}</div>
              <button class="btn-close btn-close-white me-2 m-auto" type="button" (click)="alertClose()"></button>
          </div>
      </div>
    </div>
    <footer class="footer w-100">
      <app-footer></app-footer>
    </footer>
  </div>
</div>
